import React, { useEffect } from 'react';
import { heroContent } from '@anonymizePro/mock/contents';
import HeroImageEffect from '@anonymizePro/components/hero-section/hero-image-effect';
import Logo from '@anonymizePro/components/icons/logo';
import { useRouter } from 'next/router';
import { useLazyGetAuthUrlQuery } from '@app/store/login/api';
import { motion } from 'framer-motion';

function HeroSection() {
    const router = useRouter();
    const [getAuthUrl, data] = useLazyGetAuthUrlQuery();

    const handleOnClick = async () => {
        try {
            await getAuthUrl(router.locale ?? 'en');
        } catch (e: any) {
            console.error('error: ', e);
        }
    };

    useEffect(() => {
        if (data.isSuccess) {
            router.push(data.data.authorizationUrl);
        }
    }, [data.isSuccess]);
    return (
        <div className="flex w-full flex-col  items-center bg-gradient-to-b  from-blue-100 to-red-50 px-5 pb-[109px] lg:px-24">
            <Logo className="mt-12 lg:mt-[72px]" />
            <div className="my-12 flex max-w-[1003px] flex-col items-center lg:my-[88px]">
                <p className="anonymize-p1 text-center text-black-800">{heroContent.shortTitle}</p>
                <div className="anonymize-h1-responsive lg:h1 max-w-full pb-4 pt-2 text-center text-black-900 lg:max-w-[1003px]">
                    <span>{heroContent.automate}</span>
                    <div className={'relative inline-block'}>
                        <motion.div className={'absolute h-full w-full bg-[#3333ff66] opacity-50'} initial={{ width: '0%' }} animate={{ width: '100%' }} whileInView="visible" transition={{ duration: 0.5, ease: 'easeOut' }} viewport={{ once: true }} />
                        <span> {heroContent.secureAnonymization} </span>
                    </div>
                    <p>{heroContent.inSeconds}</p>
                </div>
                <p className="anonymize-p1 max-w-[548px] text-center text-black-700">{heroContent.description}</p>
                <div className="anonymize-p2 mt-10 h-14  cursor-pointer rounded-[8px] bg-blue-600 px-8 py-4 text-white hover:bg-blue-700 hover:!no-underline" onClick={handleOnClick}>
                    {heroContent.buttonText}
                </div>
            </div>
            <HeroImageEffect />
        </div>
    );
}

export default HeroSection;
